import React from 'react';
import { Box, Paper, Typography, Grid } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@mui/icons-material/Edit';
import EmailIcon from '@mui/icons-material/Email';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import styles from './ProcessFlow.module.css';

const ProcessFlow = () => {
    const steps = [
        {
            label: 'Baixe o modelo',
            description: 'Faça o download do modelo de planilha Excel (.xlsx) disponível nesta página.',
            icon: <DescriptionIcon />,
            color: '#5a80fb'
        },
        {
            label: 'Preencha a planilha',
            description: 'Preencha a planilha com os dados dos seus pacientes, seguindo as instruções fornecidas.',
            icon: <EditIcon />,
            color: '#ff3383'
        },
        {
            label: 'Envie por email',
            description: 'Envie a planilha preenchida para suporte@gabriela.app.br com o assunto "Importação de Pacientes - [Nome da sua clínica]".',
            icon: <EmailIcon />,
            color: '#ffb347'
        },
        {
            label: 'Processamento',
            description: 'Nossa equipe receberá sua planilha e fará o upload no sistema administrativo para processamento.',
            icon: <CloudUploadIcon />,
            color: '#5a80fb'
        },
        {
            label: 'Importação concluída',
            description: 'Após a validação e processamento, os pacientes serão importados para o sistema e você receberá uma confirmação por email.',
            icon: <DoneAllIcon />,
            color: '#4CAF50'
        }
    ];

    return (
        <Paper elevation={1} className={styles.container}>
            <Box sx={{ p: 3 }}>
                <Typography variant="h6" className={styles.sectionTitle}>
                    Fluxo do Processo de Importação
                </Typography>
                
                <Typography variant="body1" paragraph className={styles.sectionDescription}>
                    Entenda como funciona o processo completo de importação de pacientes:
                </Typography>
                
                <Box className={styles.flowContainer}>
                    <Grid container spacing={3}>
                        {steps.map((step, index) => (
                            <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
                                <div className={styles.flowCard}>
                                    <div className={styles.stepNumber} style={{ backgroundColor: step.color }}>
                                        {index + 1}
                                    </div>
                                    <div 
                                        className={styles.iconContainer} 
                                        style={{ backgroundColor: `${step.color}15`, color: step.color }}
                                    >
                                        {step.icon}
                                    </div>
                                    <Typography variant="h6" className={styles.stepTitle}>
                                        {step.label}
                                    </Typography>
                                    <Typography variant="body2" className={styles.stepDescription}>
                                        {step.description}
                                    </Typography>
                                    
                                    {index < steps.length - 1 && (
                                        <div className={styles.arrowContainer}>
                                            <ArrowForwardIcon className={styles.arrowIcon} />
                                        </div>
                                    )}
                                </div>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Box>
        </Paper>
    );
};

export default ProcessFlow;